export default __webpack_public_path__ + "static/media/Beard_10_C4.6b9bb5bf.svg";